// The Vue shell (src/components/nav/AppChrome.vue) replaced the legacy navigation chrome, whose nav /
// sidebar components no longer exist. The legacy stylesheets still lay several views out around
// those bars (top bar, side rail, bottom bar): this gives that room back, the iframe being sized to
// the content area by the Vue layout.

export const LEGACY_CHROME_STYLE_ID = 'vue-legacy-chrome';
export const LEGACY_CHROME_CLASS = 'vue-chrome';

// The id in :not() lifts every rule above the legacy selectors it overrides, the heaviest being
// body.ipad-landscape:has(.nav-close-container-desktop.visible) .page-container .agenda-container .panel.maximized.
const SCOPE = `html.${LEGACY_CHROME_CLASS}:not(#vue-chrome-boost) body`;

export function buildLegacyChromeCss() {
	return [
		`${SCOPE} .page-container { padding-top: 0 !important; }`,
		// .sidebar-padded (260px), Firefox calc(100dvh - 50px).
		`${SCOPE} .page-container .content-wrapper { padding-left: 0 !important; height: 100% !important; }`,
		// Maximized panels were laid out below the top bar, right of the 60/70px sidebar and above the bottom bar.
		`${SCOPE} .maximized, ${SCOPE} .page-container .maximized.widget, ${SCOPE} .page-container .maximized.containerPOS, ${SCOPE} .page-container .agenda-container .panel.maximized, ${SCOPE} .maximized#readonlyVisit { top: 0 !important; bottom: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; }`,
		// Fixed elements of the visit / catalogue views placed right of the sidebar or above the bottom bar (visit.less).
		`${SCOPE} #relatedDock { left: 0 !important; width: 100% !important; bottom: env(safe-area-inset-bottom) !important; }`,
		`${SCOPE} .show-related-button-container { bottom: calc(1rem + env(safe-area-inset-bottom)) !important; }`,
		// .content keeps 50px under the views for the bottom bar (style.less): the agenda sizes its calendar
		// down to the iframe bottom (agenda.js applyCalendarHeight), that padding would only make the page scroll.
		`${SCOPE} .content.vwSFAPlanning { padding-bottom: 0 !important; }`,
		// Portal page (home.less) sized for the 50px bar.
		`${SCOPE} .home { height: 100vh !important; }`,
		`${SCOPE} .home .home-footer { bottom: 0 !important; }`,
	].join('\n');
}

// Called on every iframe load (fresh legacy document), whatever the chrome mode: the legacy bars no
// longer exist anywhere, including on the login page and in the BO hidden app.
export function installLegacyChromeStyle(win) {
	const doc = win?.document;
	const root = doc?.documentElement;
	if (!root) return false;

	let style = doc.getElementById(LEGACY_CHROME_STYLE_ID);
	if (!style) {
		style = doc.createElement('style');
		style.id = LEGACY_CHROME_STYLE_ID;
		(doc.head ?? root).appendChild(style);
	}
	style.textContent = buildLegacyChromeCss();
	root.classList.add(LEGACY_CHROME_CLASS);
	return true;
}
